import {Component} from '@angular/core';

@Component({
    selector: 'importantCustomerInformation',
    template: `
<legend><strong>Important Customer</strong> Information</legend>
<ul>
  <li>Customers MUST pay the "Amount Due" by each due date in order to receive monthly credits.</li>
  <li><b>Customers that do not pay or pay after the due date any three months during the term will be removed from the Program and not allowed to re-enroll for 12 months.</b></li>
  <li>All Keeping Current Customers will be enrolled in Ameren Missouri’s Budget Billing Program.</li>
</ul>
`,
    standalone: false
})

export class ImportantCustomerInformationComponent {
}
